import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-metal-introduction',
  templateUrl: './metal-introduction.component.html',
  styleUrls: ['./metal-introduction.component.css']
})
export class MetalIntroductionComponent implements OnInit {
  @Output() goToCustomerRequest = new EventEmitter();
  constructor() { }

  MetalProducts: any[]  = [
    {
      seq: 1,
      imgUrl: 'assets/images/metal_1.png',
      type: 'FMS SYSTEM',
      model: 'S4 + P4 Line',
      manufacturer: 'SALVAGNINI'
    },
    {
      index: 2,
      imgUrl: 'assets/images/metal_2.png',
      type: 'Laser M/C',
      model: 'TruLaser 1030 fiber',
      manufacturer: 'TRUMPF'
    },
    {
      index: 3,
      imgUrl: 'assets/images/metal_3.png',
      type: 'Shearing M/C',
      model: 'DCT-3065',
      manufacturer: 'AMADA'
    },
    {
      index: 4,
      imgUrl: 'assets/images/metal_4.png',
      type: 'Shearing M/C',
      model: 'M-1245',
      manufacturer: 'AMADA'
    },
    {
      index: 5,
      imgUrl: 'assets/images/metal_5.png',
      type: 'Punching M/C',
      model: 'EMZ-3510M',
      manufacturer: 'AMADA'
    },
    {
      index: 6,
      imgUrl: 'assets/images/metal_6.png',
      type: 'Punching M/C',
      model: 'ARIES-255',
      manufacturer: 'AMADA'
    },
    {
      index: 7,
      imgUrl: 'assets/images/metal_7.png',
      type: 'Bending M/C',
      model: 'FBD-3004(4M)',
      manufacturer: 'AMADA'
    },
    {
      index: 8,
      imgUrl: 'assets/images/metal_8.png',
      type: 'Bending M/C',
      model: 'HS-1303(2M)',
      manufacturer: 'AMADA'
    },
    {
      index: 9,
      imgUrl: 'assets/images/metal_9.png',
      type: 'Bending M/C',
      model: 'RG80S(2M)',
      manufacturer: 'AMADA'
    },
    {
      index: 10,
      imgUrl: 'assets/images/metal_10.png',
      type: 'Bending M/C',
      model: 'RD50(2M)',
      manufacturer: 'AMADA'
    },
    {
      index: 11,
      imgUrl: 'assets/images/metal_11.png',
      type: 'V-Cut M/C',
      model: 'DYCV III-4012',
      manufacturer: 'Cosmic'
    }
  ];

  ngOnInit(): void {
  }

  onClickGotoRequest() {
    this.goToCustomerRequest.emit('md');
  }
}
